import React from 'react';
import styles from './AppSectionTitle.module.css';

type AppSectionTitleTag = 'h2' | 'h3';

interface AppSectionTitleProps {
  children: React.ReactNode;
  as?: AppSectionTitleTag;
  className?: string;
}

const AppSectionTitle: React.FC<AppSectionTitleProps> = ({
  children,
  as: Tag = 'h2',
  className = '',
}) => (
  <Tag className={[styles.title, className].filter(Boolean).join(' ')}>
    {children}
  </Tag>
);

export default AppSectionTitle;
